import React from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import { faMagic } from '@fortawesome/free-solid-svg-icons'
import { ActionButton } from 'shared/buttons'
import AppBadge from 'shared/badges/app-badge'
import { useGenerateRoleDescription } from 'api/hooks/use-roles'

const AiDescription = ({ role }) => {
  const generate = useGenerateRoleDescription()

  const handleGenerate = () => {
    generate.mutate(
      { roleId: role.id },
      {
        onSuccess: () => toast.success('Description generated'),
        onError: (error) =>
          toast.error(
            error?.response?.data?.error || 'Could not generate description'
          )
      }
    )
  }

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <span className="form-label mb-0">Description</span>
        <AppBadge variant="ai">AI</AppBadge>
        <ActionButton
          icon={faMagic}
          label={role.ai_description ? 'Regenerate' : 'Generate'}
          loadingLabel="Generating..."
          loading={generate.isLoading}
          variant="link"
          className="text-primary p-0 small"
          onClick={handleGenerate}
        />
      </div>

      {role.ai_description_generated_at && (
        <div className="text-muted small mb-2">
          Generated{' '}
          {moment(role.ai_description_generated_at).format(
            'MMM D, YYYY h:mm A'
          )}{' '}
          from this role&apos;s current permissions, data access, and conflicts.
        </div>
      )}

      {role.ai_description ? (
        <div style={{ whiteSpace: 'pre-wrap' }}>{role.ai_description}</div>
      ) : (
        <span className="text-muted">
          No description yet. Generate one to summarize what this role can
          actually do.
        </span>
      )}
    </>
  )
}

export default AiDescription
